import { useTrackAssetModalClosed } from '@air/analytics';
import { type CloseAssetModalLocations } from '@air/analytics';
import Router from 'next/router';
import { useCallback } from 'react';

import { getQueryWithoutAssetModalParams } from '~/components/AssetModal/shared/assetModalUtils';
import { pushWithExistingQuery } from '~/utils/PathUtils';

export type useCloseAssetModalProps = {
  trackLocation: CloseAssetModalLocations;
};

export const useCloseAssetModal = ({ trackLocation }: useCloseAssetModalProps) => {
  const { trackAssetModalClosed } = useTrackAssetModalClosed();
  const closeAssetModal = useCallback(() => {
    Router.ready(() => {
      const query = getQueryWithoutAssetModalParams();
      const pathname = Router.asPath.split('/c/')[0];
      return pushWithExistingQuery({
        path: pathname,
        newQuery: query,
      });
    });

    trackAssetModalClosed({ location: trackLocation });
  }, [trackAssetModalClosed, trackLocation]);

  return {
    closeAssetModal,
  };
};
